import React from "react"

import Layout from "../components/layout/layout"
import Future from "../components/sections/future"
import styled from "styled-components"
import SEO from "../components/seo/seo"
import FullScreenCarousel from "../components/ui/fullscreen-carousel"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Container, { Row, Third, TwoThird } from "../components/layout/container"
import Sidemenu from "../layout/sidebar";
import AboutSidemenu from "../components/layout/sidebar-about";
import GettingHere from "../components/sections/getting-here"
import About from "../components/sections/about"
import MoreFromMarket from "../components/sections/more-from-market"

const Slide = styled.div`
  position: relative;
    text-align: center;
    cursor: grab;
    .image {
      opacity: 1;
      transition: 0.3s;
    }
    .centered {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        opacity: 1;

        h2 {
          transform: translate(-50%,-50%);
          left: 50%;
          top: 43%;
          position: absolute;
          width: 100%;
          color: #FFFFFF;
      }
    }

`
const ContainerRowChange = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.tablet}) {
    flex-direction: row;
  }
  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.phone}) {
    flex-direction: column;
  }
`

const IndexPage = () => {
    const data = useStaticQuery(graphql`{
            contentfulAboutPage {
                title
                heroSlider {
                  title
                  image {
                    gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
                  }
                }
            }
        }
    `)
      if (data.contentfulAboutPage.featuredImage === null) {
        var featuredImageTrue = false;

      }
      else if (data.contentfulAboutPage.featuredImage != null) {
        var featuredImageTrue = true;
      }
  return (
    <Layout>
      <SEO title="" description="" />
        <Container>
        <FullScreenCarousel>{
            data.contentfulAboutPage.heroSlider.map(photo=>{
                return <Slide><GatsbyImage image={photo.image.gatsbyImageData} /><div className="centered"><h2>{photo.title}</h2></div></Slide>
                        
            })}
        </FullScreenCarousel>
        </Container>
        <Container>
            <ContainerRowChange>
                <Third>
                    <AboutSidemenu />
                </Third>
                <TwoThird>
                    <About />
                    <MoreFromMarket />
                </TwoThird>
            </ContainerRowChange>
        </Container>
    </Layout>
    
  );
}

export default IndexPage